import {
  Users,
  UserRoundPlus,
  CalendarCheck2,
  ShieldCheck,
  ShieldPlus,
} from "lucide-react";

/**
 * Staff hub — split out from the original combined "Students & Staff" hub.
 *
 * Covers:
 * - Staff members
 * - Staff attendance
 * - Roles and permissions
 *
 * `icon` values are Lucide React components.
 * The visual decoration for these icons is handled centrally by HubIcon.
 */
export const hubStaffLinks = [
  {
    sectionTitle: "Staff Management",
    sectionIcon: Users,

    links: [
      {
        label: "Staff List",
        url: "/staff",
        desc: "All staff members",
        module: "STAFF_MANAGEMENT",
        permission: "STAFF_MANAGEMENT_VIEW",
        icon: Users,
      },

      {
        label: "Add Staff",
        url: "/staff/create",
        desc: "Onboard a new staff member",
        module: "STAFF_MANAGEMENT",
        permission: "STAFF_MANAGEMENT_FULL",
        icon: UserRoundPlus,
      },

      {
        label: "Staff Attendance",
        url: "/staff-attendance",
        desc: "Daily attendance records for staff",
        module: "STAFF_ATTENDANCE",
        permission: "STAFF_ATTENDANCE_VIEW",
        icon: CalendarCheck2,
      },
    ],
  },

  {
    sectionTitle: "Role Management",
    sectionIcon: ShieldCheck,

    links: [
      {
        label: "Manage Roles",
        url: "/roles",
        desc: "View & edit roles",
        module: "ROLE_MANAGEMENT",
        permission: "ROLE_MANAGEMENT_VIEW",
        icon: ShieldCheck,
      },

      {
        label: "Create Role",
        url: "/roles/create",
        desc: "Define a new role",
        module: "ROLE_MANAGEMENT",
        permission: "ROLE_MANAGEMENT_FULL",
        icon: ShieldPlus,
      },
    ],
  },
];

export default hubStaffLinks;